module.exports = __webpack_public_path__ + "img/29_6.7b9342db.png";